import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'freight.tracking.detail:tabs': [
    {
      widgetId: 'rail_tracking.injection.rail-tracking-positions-tab',
      kind: 'tab',
      groupLabel: 'Rail GPS Positions',
      priority: 20,
    },
  ],
}

export default injectionTable
